// `video.dub`: live's Video Dubbing tool (#215).
// Live's label map; the tool's own form builds the body.
import { VideoDubQuote, VideoDubRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.dub"> = {
  type: "video.dub",
  label: "Video Dubbing",
  source: "form",
  pair: "video.dub",
  fields: () => ({}),
  request: VideoDubRequest,
  quote: VideoDubQuote,
};
